import React from "react";

const APIURL = 'https://new.proschoolerp.com';
 
export default APIURL;